module.exports = {
    alphabet: {
        en: "Alphabet",
        fi: "Aakkoset"
    },
    noStoresFound: {
        en: "No Stores found",
        fi: "Yrityksiä ei löydetty"
    },
    city: {
        en: "City",
        fi: "Kaupunki"
    }
};